module.exports = __webpack_public_path__ + "static/media/festival2023_online_600.aaed6d67.jpg";